<demooz-modal-media #modalMedia />

<div class="challenge_response" [class]="this.responseChallengeStatus.classCSS">
    <div class="challenge_response_header">
        <div class="page_title_content">
            <div class="page_title">
                <div class="page_title_text">{{this.challenge.title | translate}}</div>  
                @if(this.levelLabel){
                    <div class="challenge_response_level">{{this.levelLabel}}</div>
                }
                @if(!this.externalLink){
                    <div class="challenge_response_status">{{this.responseChallengeStatus.label | translate}}</div>
                }
            </div>      
        </div>
        @if(!this.externalLink){
            <div class="challenge_response_incentives" [class.lost_incentives]="this.lostIncentives">
                @if(this.incentivePointsLabel != ''){
                    <div class="challenge_response_incentive incentive_points" [innerHTML]="this.incentivePointsLabel"></div>
                }
                @if(this.incentiveLabel != ''){
                    <div class="challenge_response_incentive" [innerHTML]="this.incentiveLabel"></div>
                }
            </div>
        }
    </div>
    
    <form class="challenge_response_form" [formGroup]="this.responseForm" (ngSubmit)="this.submitResponse()">
        <div #challengeResponseContent class="challenge_response_content">
        
            <div class="challenge_response_description" [innerHTML]="this.description"></div>
            
            @if(this.responseChallenge 
                && this.responseChallenge.status 
                && [environment.CHALLENGE_VALIDATION_TYPE.DENIED, environment.CHALLENGE_VALIDATION_TYPE.DENIED_DEFINITELY].indexOf(this.responseChallenge.status) !== -1
                && this.responseChallenge.message
                ){
                <demooz-message type="error">{{this.responseChallenge.message}}</demooz-message>
            }

            @if(this.match?.salesDeniedDefinitely){
                <demooz-message type="error">{{'CHALLENGE_RESPONSE.MSG_ERROR_RESPONSE_ALREADY_SENT' | translate}}</demooz-message>
            }
            @else if(this.nbSalesResponses >= this.salesContent?.nbMaxSales){
                <demooz-message type="error">{{'CHALLENGE_RESPONSE.MSG_ERROR_RESPONSE_NB_SALES_MAX' | translate}}</demooz-message>
            }
            
            @if(this.challenge){
                @if(this.challenge.isSocialsEnabled){
                    <div class="challenge_response_socials">
                        <div class="challenge_response_socials_title">{{'CHALLENGE_RESPONSE.SOCIAL_TITLE' | translate}}</div>                    
                        <div class="challenge_response_socials_description">{{'CHALLENGE_RESPONSE.SOCIAL_DESCRIPTION' | translate}}</div>                    
                        <div class="challenge_response_socials_logos" (click)="this.shareSocials()">
                            <img src="./assets/imgs/facebook.png" title="Facebook"/>
                            <img src="./assets/imgs/instagram.png"  title="Instagram"/>
                            <img src="./assets/imgs/x.png" title="X" class="logo_x"/>
                        </div>
                    </div>
                }   
                @else if(this.challenge.buttonLink && this.challenge.buttonLink !== '' 
                    && this.challenge.link && this.challenge.link !== ''){
                    <div class="challenge_response_link">
                        @if(this.descriptionLink != ''){
                            <div class="challenge_response_link_description" [innerHTML]="this.descriptionLink"></div>
                        }
                        <demooz-button type="button" [label]="this.challenge.buttonLink" (click)="this.openLinkChallenge()" />
                    </div>
                }

                @if(this.challenge.hashtags && this.challenge.hashtags.length > 0){
                    <div class="challenge_response_hashtags" (click)="this.copyHashtagsToClipboard()">
                        <ion-icon name="clipboard-outline"></ion-icon>
                        {{this.challenge.hashtags.join(' ')}}
                    </div>
                }

                @if(this.challengeMedia){
                    <div class="challenge_response_media">
                        @switch(this.challengeMedia.type){
                            @case('picture'){
                                <img [src]="this.challengeMedia.src" (click)="this.showMedia()"/>
                            }
                            @case('video'){
                                <video [src]="this.challengeMedia.src" controls></video>
                            }
                        }
                    </div>
                }
            }
                
            @if(this.canPostResponse){
            
                <div class="challenge_response_proof">
                    
                    @if(!this.externalLink){
                        <div class="challenge_response_proof_description">{{'CHALLENGE_RESPONSE.PROOF_DESCRIPTION' | translate}}</div>
                    }

                    @if(!this.externalLink && this.challenge.type === environment.CHALLENGE_TYPE.SALE){                    
                        <demooz-select                            
                            label="{{'CHALLENGE_RESPONSE.MATCH_DEMONSTRATION' | translate}}" 
                            formName="match" 
                            [items]="this.matchsDemonstrationsValidated" 
                            textAlign="left" 
                            [disabled]="this.disabled" 
                            />
                    }
                    
                    <demooz-select 
                        [class.hide_proof_type]="(this.disabled || this.responsesTypesOptions.length <= 1)"
                        label="{{'CHALLENGE_RESPONSE.SELECT_PROOF_TYPE' | translate}}" 
                        formName="responseType" 
                        [items]="this.responsesTypesOptions" 
                        interface="popover"
                        [withSearch]="false" 
                        textAlign="left" 
                        />

                    @if(['media', 'video'].indexOf(this.responseForm.controls['responseType'].value) !== -1){    
                        @if(!this.disabled){
                            <demooz-input-file 
                                formName="proof_file" 
                                class="field_proof"
                                [(file)]="this.proofFile" 
                                [label]="this.translateService.instant('CHALLENGE_RESPONSE.PROOF_FILE') + this.infosFile" 
                                icon="document-attach-outline" 
                                [showBtnClearInput]="true" 
                                [acceptFiles]="this.acceptFiles"
                                [errorText]="this.errorFile || this.translateService.instant('MAIN.MSG_ERROR_FILE_MANDATORY')"
                                />
                        }        
                        @if(this.responseChallenge && this.responseChallenge.response && this.responseChallenge.response != ''){
                            <demooz-button                                 
                                type="button" 
                                class="btn_download_media"
                                label="{{'CHALLENGE_RESPONSE.DOWNLOAD_FILE' | translate}}" 
                                icon="download-outline" 
                                (click)="this.downloadMedia(this.responseChallenge.response)"
                                />
                        }
                    }
                    @else if(['url', 'text'].indexOf(this.responseForm.controls['responseType'].value) !== -1){                   
                        <demooz-input 
                            type="text" 
                            formName="proof" 
                            class="field_proof"
                            label="{{'CHALLENGE_RESPONSE.PROOF' | translate}}"
                            [errorText]="this.errorText || this.translateService.instant('MAIN.MSG_ERROR_FIELD_MANDATORY')"
                            [disabled]="this.disabled" 
                            />
                    }
                    @else if(['longtext'].indexOf(this.responseForm.controls['responseType'].value) !== -1){                   
                        <demooz-textarea 
                            formName="proof" 
                            class="field_proof"
                            label="{{'CHALLENGE_RESPONSE.PROOF' | translate}}"
                            [errorText]="this.errorText || this.translateService.instant('MAIN.MSG_ERROR_FIELD_MANDATORY')"
                            [disabled]="this.disabled" 
                            />                    
                    }     
                    
                    @if(this.challenge.commentEnabled){
                        <demooz-textarea 
                            formName="comment" 
                            [label]="this.challenge.commentLabel" 
                            [fixedLabel]="true" 
                            [disabled]="this.disabled" 
                            />
                    }

                    @if(this.challenge.checkboxEnabled && !this.disabled){
                        <demooz-checkbox 
                            formName="checkbox" 
                            [label]="this.challenge.checkboxLabel" 
                            labelPlacement="end" 
                            />       
                    }
                    
                </div>
                            
                @if(this.challenge.optionalsMediasEnabled){
                    <div class="challenge_response_optionals_medias">

                        <demooz-input-file 
                            #optionalMediaInput
                            class="challenge_response_optional_media_input"
                            formName="optional_media"                                                 
                            [acceptFiles]="this.acceptFilesOptionalsMedias"
                            (fileChange)="this.selectOptionalMedia($event)"
                            />

                        <div class="challenge_response_optionals_medias_title">
                            {{'CHALLENGE_RESPONSE.OPTIONALS_MEDIAS_TITLE' | translate}}  
                            <div class="challenge_response_optionals_medias_action">
                                @if(this.challenge.optionalsMediasMax != 0){
                                    {{this.optionalsMedias.length}} / {{this.challenge.optionalsMediasMax}}
                                }
                                
                                @if(!this.disabled){                                
                                    <demooz-button 
                                        type="button" 
                                        [class.hide]="(this.challenge.optionalsMediasMax != 0 && (this.optionalsMedias.length >= this.challenge.optionalsMediasMax))"
                                        icon="add-outline" 
                                        size="small"
                                        (click)="this.addOptionalMedia()" 
                                        />           
                                }
                            </div>
                        </div>
                        <div class="challenge_response_optionals_medias_list">
                            @if(this.optionalsMedias.length > 0){
                                @for(optionalMedia of this.optionalsMedias; track $index){
                                    <div class="challenge_response_optional_media">
                                        @if(!this.disabled){
                                            <div 
                                                class="challenge_response_optional_media_btn_remove"
                                                (click)="this.removeOptionalMedia($index)"
                                                >
                                                <ion-icon name="close-circle-outline"></ion-icon>
                                            </div>
                                        }
                                        <ion-icon name="document-outline"></ion-icon>
                                        @if(optionalMedia.file && optionalMedia.file.name){
                                            <div class="challenge_response_optional_media_name">{{optionalMedia.file.name}}</div>
                                        }
                                        @if(optionalMedia.url){
                                            <demooz-button                                 
                                                type="button" 
                                                class="btn_download_media"                                            
                                                icon="download-outline" 
                                                size="small"
                                                (click)="this.downloadMedia(optionalMedia.url)"
                                                />
                                        }
                                    </div>
                                }                            
                            }
                            @else{
                                <demooz-message type="info">{{'CHALLENGE_RESPONSE.MSG_NO_OPTIONAL_MEDIA' | translate}}</demooz-message>
                            }
                        </div>
                    </div>
                }
            
            }
            
        </div>
        <div class="challenge_response_form_buttons">
            @if(!this.externalLink){
                <demooz-button type="button" [label]="(this.disabled || !this.canPostResponse ? this.translateService.instant('MAIN.CLOSE') : this.translateService.instant('MAIN.CANCEL'))" color="secondary" [invertColor]="true" (click)="this.cancel()"/>
            }
            @else{
                <div></div>
            }
            @if(!this.disabled && this.canPostResponse){
                <demooz-button type="submit" label="{{'CHALLENGE_RESPONSE.SUBMIT_RESPONSE' | translate}}" [isFetching]="this.isFetchingSubmit"/>
            }
            @else if (this.canEditResponse){
                <demooz-button type="button" label="{{'CHALLENGE_RESPONSE.EDIT_RESPONSE' | translate}}" (click)="this.editResponse()"/>
            }
        </div>

    </form>    
    
    
</div>